import { FC } from 'react'
import { Divider } from '../../../Divider'
import { CountryType } from '../../types/CountryType'
import { AddressSection } from './components/AddressSection'
import { AdditionalInformationSection } from './components/AdditionalInformationSection'
import { BankAccountSection } from './components/BankAccountSection'
import { WorkProfileSection } from './components/WorkProfileSection'

interface Props {
  countries: CountryType[]
  taxCodes: string[]
}

export const FormContent: FC<Props> = ({ countries, taxCodes }) => {
  return (
    <>
      <BankAccountSection />
      <Divider sectionSeparator />
      <AddressSection countries={countries} />
      <Divider sectionSeparator />
      <AdditionalInformationSection countries={countries} />
      <Divider sectionSeparator />
      <WorkProfileSection taxCodes={taxCodes} />
    </>
  )
}
